import { API, METHODS } from '../constants';
import { fetchData } from '../utils';

export const manufacturingLogsData = async ({ data = {} }) => {
  const url = API.MANUFACTURING_LOGS;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};

export const manufacturingLogLineData = async ({ data = {} }) => {
  const url = API.MANUFACTURING_LOG_LINES;
  const response = await fetchData({ body: { ...data }, method: METHODS.POST, url });
  return response;
};